import * as React from "react";
import styled from "styled-components";
import { colors } from "../styles/variables";
import { ICurrency } from "../ShoppingCart/types";
import { priceWithCommas } from "../utils/commonHelper";
import { getLocale } from "../utils/pathHelper";

const PriceView = styled.div`
  margin: 0.2em 0;
  line-height: 1.2em;
  text-align: right;
  & > .discount {
    margin-bottom: 0.1em;
    .discount-rate {
      font-size: 0.6em;
      font-weight: bold;
      background-color: ${colors.red};
      padding: 0.1em 0.5em;
      border-radius: 0.2em;
      color: ${colors.white};
    }
    .full-price {
      font-size: 0.7em;
      color: var(--pink600);
      text-decoration: line-through;
      margin-left: 0.4em;
    }
  }
  & > .price-container {
    & > div {
      display: inline-block;
    }
    .jpy-price {
      font-size: var(--font-size-xxs);
      color: var(--gray-600);
    }

    .local-currency-price {
      margin-left: var(--spacing-xs);
      color: var(--pink600);
      font-weight: bold;

      .currency {
        font-size: var(--font-size-xs);
      }

      .amount {
        font-size: var(--font-size-l);
      }

      .strike {
        text-decoration: line-through;
      }
    }
  }
`;

interface IPricePrimaryProps {
	isStrikeThrough?: boolean;
	price: number;
	fullPrice?: number;
	showDiscount?: boolean;
	fontSize?: number;
	style?: any;
	localCurrency?: ICurrency;
	showJPY?: boolean;
	wavyLine?: boolean;
}

const PricePrimary: React.FC<IPricePrimaryProps> = ({
	isStrikeThrough,
	price,
	fullPrice,
	showDiscount,
	fontSize,
	style,
	localCurrency,
	showJPY = true,
	wavyLine = false,
}) => {
	const locale = getLocale({ underscore: true });
	const styling = { ...style, fontSize: fontSize ? fontSize : 16 };
	const discountRate = fullPrice
		? Math.floor(((fullPrice - price) / fullPrice) * 100)
		: 0;
	const fullPriceCurrencies: { code: string; fullPrice: number }[] = [
		{ code: "JPY", fullPrice },
	];
	const { rate } = localCurrency || {};
	if (rate != null) {
		fullPriceCurrencies.push({
			code: localCurrency.code,
			fullPrice: Math.round(fullPrice * rate),
		});
	}

	if (locale.toString() == "ja") {
		return (
			<PriceView style={styling}>
				{!!fullPrice && showDiscount && discountRate > 0 && (
					<div className="discount">
						<span className="discount-rate">{discountRate}%OFF</span>
						{showJPY && (
							<span className="full-price">{priceWithCommas(fullPrice)}円</span>
						)}
					</div>
				)}
				<div className="price-container">
					{showJPY && (
						<div>
							<span className={`amount ${isStrikeThrough && "strike"}`}>
								{priceWithCommas(price)}
								<span className="currency">円</span>
								{wavyLine ? "〜" : ""}
							</span>
						</div>
					)}
				</div>
			</PriceView>
		);
	} else {
		return (
			<PriceView style={styling}>
				{!!fullPrice && showDiscount && discountRate > 0 && (
					<div className="discount">
						<span className="discount-rate">{discountRate}%OFF</span>
						{showJPY && (
							<span className="full-price">
								JPY{" "}
								{Math.round(fullPrice)
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
							</span>
						)}
					</div>
				)}
				<div className="price-container">
					{showJPY && (
						<div>
							<span className="jpy-price">{`JPY ${Math.round(price)
								.toString()
								.replace(
									/\B(?=(\d{3})+(?!\d))/g,
									",",
								)}${wavyLine ? "〜" : ""}`}</span>
						</div>
					)}
					{!!rate && (
						<div className="local-currency-price">
							<span className="currency">{localCurrency.code}</span>
							<span className={`amount ${isStrikeThrough && "strike"}`}>
								{priceWithCommas(price * rate)}
								{wavyLine ? "〜" : ""}
							</span>
						</div>
					)}
				</div>
			</PriceView>
		);
	}
};

export default PricePrimary;
